import { useCallback, useState } from "react";
import { ISubscription } from "../../interfaces/ISubscriptions";
import { useConsumerController } from "../useConsumerController/useConsumerController";

export const useGetSubscription = (): [
  ISubscription | undefined,
  boolean,
  Error | undefined,
  (consumerId: string, subscriptionId: string) => Promise<ISubscription>
] => {
  const [data, setData] = useState<ISubscription>();

  const { get, response, loading, error } =
    useConsumerController<ISubscription>(false);

  const getSubscription = useCallback(
    async (consumerId: string, subscriptionId: string) => {
      const subscription = await get(`/${consumerId}/subscriptions/${subscriptionId}`);

      if (response.ok) {
        setData(subscription);
      }

      return subscription;
    },
    [get, response]
  );

  return [data, loading, error, getSubscription];
};
